module.exports = __webpack_public_path__ + "img/partner17.798ba754.png";